const styles = {
    none: {
        borderRadius: 0
    },
    small: {
        borderRadius: 4
    },
    medium: {
        borderRadius: 8
    },
    large: {
        borderRadius: 12
    },
    large_x: {
        borderRadius: 16
    },
    circle: {
        borderRadius: -1 // 当为circle的时候需要动态计算，所以赋值为-1
    }
};
export default styles;
